<template>
  <div class="list-page-container">
    <div class="control-panel">
      <div class="control-container">
        <div class="header-info">
          <i class="el-icon-present"></i>
          <span>管理活动纪念信息，设计纪念徽章、贴纸、集章等</span>
        </div>
        <div class="action-wrapper">
          <el-button
            v-if="hasPermission('activity:memorial:save')"
            type="primary"
            icon="el-icon-plus"
            @click="handleAdd"
          >
            创建纪念
          </el-button>
        </div>
      </div>
    </div>

    <div class="control-panel has-query">
      <div class="control-container">
        <el-form :inline="true" :model="searchForm" class="filter-form" @submit.native.prevent>
          <el-form-item>
            <el-input v-model="searchForm.title" placeholder="纪念标题" clearable class="filter-input" @keyup.enter.native="handleSearch" @clear="handleSearch">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-select v-model="searchForm.seriesName" placeholder="纪念系列" clearable class="filter-select" @change="handleSearch">
              <el-option v-for="item in seriesOptions" :key="item.key" :label="item.name" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="searchForm.memorialType" placeholder="纪念类型" clearable class="filter-select" @change="handleSearch">
              <el-option v-for="item in typeOptions" :key="item.key" :label="item.name" :value="item.key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="searchForm.status" placeholder="状态" clearable class="filter-select" @change="handleSearch">
              <el-option label="草稿" value="DRAFT"></el-option>
              <el-option label="已发布" value="PUBLISHED"></el-option>
              <el-option label="已过期" value="EXPIRED"></el-option>
              <el-option label="已禁用" value="DISABLED"></el-option>
            </el-select>
          </el-form-item>
          <div class="search-btns">
            <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
          </div>
        </el-form>
      </div>
    </div>

    <div class="statistics-panel" v-if="statistics">
      <div class="stat-card stat-total">
        <div class="stat-value">{{ statistics.total || 0 }}</div>
        <div class="stat-label">全部纪念</div>
      </div>
      <div class="stat-card stat-draft">
        <div class="stat-value">{{ statistics.draft || 0 }}</div>
        <div class="stat-label">草稿</div>
      </div>
      <div class="stat-card stat-published">
        <div class="stat-value">{{ statistics.published || 0 }}</div>
        <div class="stat-label">已发布</div>
      </div>
      <div class="stat-card stat-expired">
        <div class="stat-value">{{ statistics.expired || 0 }}</div>
        <div class="stat-label">已过期</div>
      </div>
      <div class="stat-card stat-disabled">
        <div class="stat-value">{{ statistics.disabled || 0 }}</div>
        <div class="stat-label">已禁用</div>
      </div>
    </div>

    <el-card class="list-card">
      <el-table ref="table" :data="tableData" v-loading="loading" class="custom-table" height="100%" style="width: 100%" @sort-change="handleSortChange">
        <el-table-column prop="id" label="ID" width="70" align="center" v-if="false"></el-table-column>
        <el-table-column label="图标" width="80" align="center">
          <template slot-scope="scope">
            <el-image v-if="scope.row.icon" :src="resolveUrl(scope.row.icon)" fit="cover" style="width: 40px; height: 40px; border-radius: 4px;"></el-image>
            <span v-else style="color: #c0c4cc;">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="纪念标题" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="subtitle" label="副标题" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.subtitle || '-' }}</template>
        </el-table-column>
        <el-table-column prop="seriesName" label="系列" width="100" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" effect="plain" type="info">{{ getSeriesLabel(scope.row.seriesName) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="memorialType" label="类型" width="90" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" effect="plain" :type="getTypeTagType(scope.row.memorialType)">{{ getTypeLabel(scope.row.memorialType) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="skuId" label="关联SKU" width="130" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.skuId" style="color: #409EFF; font-size: 12px;">{{ scope.row.skuName || scope.row.skuId }}</span>
            <span v-else style="color: #c0c4cc;">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)" size="mini" effect="plain">{{ getStatusLabel(scope.row.status) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="acquireCount" label="获取次数" width="90" align="center">
          <template slot-scope="scope">{{ scope.row.acquireCount || 0 }}</template>
        </el-table-column>
        <el-table-column prop="antiFakeCode" label="防伪码" width="120" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.antiFakeCode || '-' }}</template>
        </el-table-column>
        <el-table-column label="创建时间" width="160" align="center">
          <template slot-scope="scope">{{ formatDate(scope.row.createDate) }}</template>
        </el-table-column>
        <el-table-column v-if="hasAnyActionPermission" :label="$t('common.operation')" :width="actionColumnWidth" fixed="right" align="center">
          <template slot-scope="scope">
            <div class="action-buttons">
              <el-button v-if="hasPermission('activity:memorial:update')" type="warning" size="mini" plain icon="el-icon-edit" @click="handleEdit(scope.row)">编辑</el-button>
              <el-button v-if="hasPermission('activity:memorial:update')" class="btn-action-status" size="mini" plain icon="el-icon-setting" @click="openStatusDialog(scope.row)">{{ $t('common.status') }}</el-button>
              <el-button v-if="hasPermission('activity:memorial:delete')" type="danger" size="mini" plain icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
        ></el-pagination>
      </div>
    </el-card>

    <el-dialog title="变更纪念状态" :visible.sync="statusDialogVisible" width="500px" :close-on-click-modal="false">
      <div v-if="statusChangeRow" style="margin-bottom: 16px;">
        <span>当前纪念：</span><strong>{{ statusChangeRow.title }}</strong>
        <el-tag :type="getStatusType(statusChangeRow.status)" size="small" style="margin-left: 8px;">{{ getStatusLabel(statusChangeRow.status) }}</el-tag>
      </div>
      <el-form ref="statusForm" :model="statusFormData" :rules="statusFormRules" label-width="80px">
        <el-form-item label="目标状态" prop="targetStatus">
          <el-select v-model="statusFormData.targetStatus" placeholder="请选择目标状态" style="width: 100%">
            <el-option label="草稿" value="DRAFT"></el-option>
            <el-option label="已发布" value="PUBLISHED"></el-option>
            <el-option label="已过期" value="EXPIRED"></el-option>
            <el-option label="已禁用" value="DISABLED"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="statusDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleStatusChange" :loading="statusLoading">确认变更</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getMemorialPage,
  getMemorialStatistics,
  deleteMemorial,
  updateMemorialStatus
} from '@/apis/activity/memorial'
import { getDictDataByType } from '@/apis/system/dict'
import { hasPermission } from '@/utils/permission'
import { getFullUrl } from '@/utils'

export default {
  name: 'MemorialList',
  data() {
    return {
      loading: false,
      tableData: [],
      page: 1,
      limit: 10,
      total: 0,
      seriesOptions: [],
      seriesMap: {},
      typeOptions: [],
      typeMap: {},
      searchForm: {
        title: '',
        seriesName: '',
        memorialType: '',
        status: ''
      },
      statistics: null,
      statusDialogVisible: false,
      statusChangeRow: null,
      statusFormData: { targetStatus: '' },
      statusFormRules: {
        targetStatus: [{ required: true, message: '请选择目标状态', trigger: 'change' }]
      },
      statusLoading: false
    }
  },
  created() {
    this.loadDictData()
    this.loadData()
    this.loadStatistics()
  },
  computed: {
    visibleActionCount() {
      let count = 0
      if (this.hasPermission('activity:memorial:update')) count += 2
      if (this.hasPermission('activity:memorial:delete')) count += 1
      return count
    },
    hasAnyActionPermission() {
      return this.visibleActionCount > 0
    },
    actionColumnWidth() {
      const count = this.visibleActionCount
      const widthMap = { 1: 100, 2: 170, 3: 245, 4: 300 }
      return widthMap[count] || 0
    }
  },
  methods: {
    hasPermission,
    resolveUrl(url) {
      return getFullUrl(url)
    },
    loadDictData() {
      getDictDataByType('MEMORIAL_SERIES').then(res => {
        const data = res || []
        this.seriesOptions = data
        this.seriesMap = {}
        data.forEach(item => { this.seriesMap[item.key] = item.name })
      }).catch(e => {
        console.error('加载纪念系列字典失败:', e)
        this.seriesOptions = []
      })
      getDictDataByType('MEMORIAL_TYPE').then(res => {
        const data = res || []
        this.typeOptions = data
        this.typeMap = {}
        data.forEach(item => { this.typeMap[item.key] = item.name })
      }).catch(e => {
        console.error('加载纪念类型字典失败:', e)
        this.typeOptions = []
      })
    },
    loadData() {
      this.loading = true
      const params = {
        page: this.page,
        limit: this.limit,
        title: this.searchForm.title || undefined,
        seriesName: this.searchForm.seriesName || undefined,
        memorialType: this.searchForm.memorialType || undefined,
        status: this.searchForm.status || undefined
      }
      getMemorialPage(params).then(res => {
        if (res) {
          this.tableData = res.list || []
          this.total = res.total || 0
        }
      }).catch(e => {
        console.error('加载纪念列表失败:', e)
      }).finally(() => {
        this.loading = false
      })
    },
    loadStatistics() {
      getMemorialStatistics({}).then(res => {
        if (res) {
          this.statistics = res
        }
      }).catch(e => {
        console.error('加载纪念统计失败:', e)
      })
    },
    handleSearch() {
      this.page = 1
      this.loadData()
    },
    handleReset() {
      this.searchForm = { title: '', seriesName: '', memorialType: '', status: '' }
      this.page = 1
      this.loadData()
    },
    handleSizeChange(val) {
      this.limit = val
      this.page = 1
      this.loadData()
    },
    handleCurrentChange(val) {
      this.page = val
      this.loadData()
    },
    handleSortChange() {
      this.loadData()
    },
    handleAdd() {
      this.$router.push('/activity/memorial/add')
    },
    handleEdit(row) {
      this.$router.push(`/activity/memorial/edit/${row.id}`)
    },
    handleDelete(row) {
      this.$confirm('确定要删除该纪念吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteMemorial([row.id]).then(() => {
          this.$message.success('删除成功')
          this.loadData()
          this.loadStatistics()
        })
      }).catch(() => {})
    },
    openStatusDialog(row) {
      this.statusChangeRow = row
      this.statusFormData.targetStatus = ''
      this.statusDialogVisible = true
    },
    handleStatusChange() {
      this.$refs.statusForm.validate(valid => {
        if (!valid) return
        this.statusLoading = true
        updateMemorialStatus(this.statusChangeRow.id, this.statusFormData.targetStatus).then(() => {
          this.$message.success('状态变更成功')
          this.statusDialogVisible = false
          this.loadData()
          this.loadStatistics()
        }).finally(() => {
          this.statusLoading = false
        })
      })
    },
    formatDate(dateStr) {
      if (!dateStr) return '-'
      const d = new Date(dateStr)
      const pad = n => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
    },
    getSeriesLabel(val) {
      return this.seriesMap[val] || val || '-'
    },
    getTypeLabel(val) {
      return this.typeMap[val] || val || '-'
    },
    getTypeTagType(val) {
      const map = { BADGE: '', STICKER: 'success', STAMP: 'warning', MEDAL: 'danger', CERTIFICATE: 'info' }
      return map[val] || 'info'
    },
    getStatusLabel(status) {
      const map = { DRAFT: '草稿', PUBLISHED: '已发布', EXPIRED: '已过期', DISABLED: '已禁用' }
      return map[status] || status
    },
    getStatusType(status) {
      const map = { DRAFT: 'info', PUBLISHED: 'success', EXPIRED: 'warning', DISABLED: 'danger' }
      return map[status] || 'info'
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/list-page.scss";

.statistics-panel {
  display: flex;
  gap: 12px;
  margin-top: 10px;
  flex-wrap: wrap;
}

.stat-card {
  flex: 1;
  min-width: 100px;
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  text-align: center;
  border: 1px solid #f1f5f9;
  border-left: 3px solid #409eff;
  transition: box-shadow 0.3s;

  &:hover {
    box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.06);
  }

  &.stat-draft { border-left-color: #909399; }
  &.stat-published { border-left-color: #67c23a; }
  &.stat-expired { border-left-color: #e6a23c; }
  &.stat-disabled { border-left-color: #f56c6c; }
}

.stat-value {
  font-size: 24px;
  font-weight: 700;
  color: #303133;
}

.stat-label {
  font-size: 13px;
  color: #909399;
  margin-top: 4px;
}
</style>
